import Axios from 'axios'

export const api = Axios.create({
  baseURL: `${process.env.VUE_APP_API_PROTOCOL}//${process.env.VUE_APP_API_HOST}`,
  timeout: 60000,
});
